import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-33ebce51"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col" }, [
    /*#__PURE__*/_createElementVNode("h1", null, "Cities Explorer")
  ])
], -1))
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-8 offset-2" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_cities_search = _resolveComponent("cities-search")!
  const _component_cities_list = _resolveComponent("cities-list")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_cities_search, { onOnFilterCities: _ctx.onFilterCities }, null, 8, ["onOnFilterCities"])
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_cities_list, {
          cities: _ctx.cities,
          onOnSortCities: _ctx.onSortCities
        }, null, 8, ["cities", "onOnSortCities"])
      ])
    ])
  ], 64))
}